
export default function YanikQuote() {
  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-3xl mx-auto text-center">
        {/* Intro line with Yanik Silver mention */}
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8" style={{ fontFamily: "'Inter', sans-serif" }}>
          A philosophy I deeply align with is that of{' '}
          <a
            href="https://www.yaniksilver.com"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="underline hover:opacity-70 transition-opacity cursor-pointer"
            style={{ color: '#D97706' }}
          >
            Yanik Silver
          </a>:
        </p>

        {/* Quote */}
        <blockquote className="mb-6">
          <p className="text-xl md:text-2xl font-medium text-gray-800 italic">
            "Play(fully). Purpose(fully). Profit(fully)."
          </p>
        </blockquote>

        {/* Supporting line */}
        <p className="text-base text-gray-600 max-w-xl mx-auto leading-relaxed">
          A reminder that meaningful business can be joyful, values driven, and profitable at the same time.
        </p>
      </div>
    </section>
  );
}
